/**
 * The BE returns `industry`/`subcategory` as nested objects but only reads `industryId`/`subcategoryId`
 * on save, and unsets the industry when the IDs are missing. Swaps the objects for their IDs.
 * An explicit `industryId`/`subcategoryId` (set by the profile forms) wins over the nested object.
 * @param {Object} employee - Employee data as held in the store
 * @returns {Object} Employee data safe to POST to /employees/{id}
 */
export function toEmployeePayload(employee) {
    const { industry, subcategory, ...rest } = employee;
    const industryId = employee.industryId ?? industry?.id;
    const subcategoryId = employee.subcategoryId ?? subcategory?.id;

    return {
        ...rest,
        ...(industryId !== undefined && { industryId }),
        ...(subcategoryId !== undefined && { subcategoryId }),
    };
}
